module.exports = __webpack_public_path__ + "media/images/NPORTlogo-2acea58cd325ea877754e4c202c7bec3.jpg";